import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import Validate from '../lib/validate';
import Helpers from '../lib/helpers';
import {connect} from 'react-redux';
import Settings from '../lib/settings';

class AddCategory extends Component {

  constructor(props) {
    super(props);
    this.state = {
      categories: []

    }

    this.handleAddCategory = this.handleAddCategory.bind(this);
    this.removeCategory = this.removeCategory.bind(this);

  };
  //this.addFormMessage = this.handleSubmit.bind(this);

  componentDidMount() {
    fetch('/api/categories/', Settings.fetchParams('GET')).then(res => res.json()).then(json => {

        this.setState({categories: json});

    });
    window.scrollTo(0, this.props.menuPosition);
  }

  componentDidUpdate() {
    //window.scrollTo(0, this.props.menuPosition);
  }

  removeCategory(i) {

    let items = this.state.categories;


    fetch('/api/categories', Settings.fetchParams('DELETE', {_id: this.state.categories[i]._id})).then(res => {
      if (res.ok) {
        return res.json()
      } else {
        alert("Error");
      }
    }).then(json => {
      if (!json.error) {

        items.splice(i, 1);
        this.setState({categories: items});

      } else {
        alert(json.error)
      }
    });

  }

  handleAddCategory(i, event) {
    event.preventDefault();

    var value;
    if(i !== false) {
      value = ReactDOM.findDOMNode(this.refs["subcategory" + i]).value;
      ReactDOM.findDOMNode(this.refs["subcategory" + i]).value = "";
    } else {
      value = ReactDOM.findDOMNode(this.refs.category).value;
      ReactDOM.findDOMNode(this.refs.category).value = "";
    }

    let dataToFetch = {
      name: value
    }

    if (value !== "" && Validate.category(dataToFetch , "for_insert")) {


      if(i !== false) {
        dataToFetch.parent = this.state.categories[i]._id;
      }

      fetch('/api/categories', Settings.fetchParams('POST', dataToFetch)).then(res => {
        if (res.ok) {
          return res.json()
        } else {
          alert("Error");
        }
      }).then(json => {
        if (!json.error) {

          if(i !== false) {
            this.setState({
              categories: [
                ...this.state.categories, {
                  _id: json.category._id,
                  name: json.category.name,
                  slug: json.category.slug,
                  parent: json.category.parent
                }
              ]
            });
          } else {
            this.setState({
              categories: [
                ...this.state.categories, {
                  _id: json.category._id,
                  name: json.category.name,
                  slug: json.category.slug
                }
              ]
            });
          }


        } else {
          console.log("Error");
        }
      });

    } else {
      alert("Vyplňte prosím kategorii/podkategorii")
    }
  }

  render() {

    const tree = Helpers.createCategoryTree(this.state.categories);
    //console.log(this.createCategoryTree(this.state.categories));
    const categories = tree.map((item, index) => <form className="subcategoryformAdd" onSubmit={(event) => {
        this.handleAddCategory(item.arrayIndex, event)
      }} key={index}>
      <div className="row">
        <div className="col50">
          <p>
            {item.name}{item.empty === true ? <i className="fas fa-times removeParam" onClick={() => {
                this.removeCategory(item.arrayIndex)
              }}></i> : ""}{
              typeof item.subcategory === "undefined"
                ? ""
                : item.subcategory.map((item2, index2) => <span key={index2}>{item2.name}{item2.empty === true ? <i className="fas fa-times removeParam" onClick={() => {
                    this.removeCategory(item2.arrayIndex)
                  }}></i> : ""}</span>)
            }
          </p>
        </div>
        <div className="col50"><input type="text" ref={"subcategory" + item.arrayIndex} value={this.state.addSubCategory} onChange={this.handleChange} name="discount"/>
          <button>+</button>
        </div>
      </div>
    </form>);

    //const parameterValues = (i) => ;
    return (<div className="form">
      <div ref="addCategory" className="addCategoriesList">
        <h1>
          Kategorie:
        </h1>

        <form onSubmit={(event) => {
            this.handleAddCategory(false, event)
          }}>
          <div className="row addCategoryForm">
            <div className="col50">
              <p className="addCategoryText">Přidat kategorii:</p>
            </div>
            <div className="col50">
              <div className="formInput"><input type="text" ref="category" value={this.state.addCategory} onChange={this.handleChange} name="discount"/>
                <button>+</button>
              </div>
              <p className="addSubcategoryText">Přidat podkategorii:<br/>
                <i className="fas fa-arrow-down"></i>
              </p>
            </div>
          </div>
        </form>
        {categories}
      </div>
    </div>);
  }
}
function mapStateToProps(state){
  return {
    admin: state.admin,
    menuPosition: state.menuPosition,
  };
}
export default connect(mapStateToProps)(AddCategory);



// WEBPACK FOOTER //
// ./src/pages/AddCategory.js